import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const protectedWord = document.querySelectorAll(".-protected span");

// protectedWord

ScrollTrigger.create({
  trigger: ".protected-section",
  start: "top top",
  end: "+=2000",
  pin: ".protected-section__content",
  // endTrigger: "#otherID",
  // end: "bottom 50%+=100px",
  // onToggle: (self) => console.log("toggled, isActive:", self.isActive),
  onUpdate: (self) => {
    // console.log('self. p')
    // console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());

    let progress = self.progress;

    // console.log(arguments);
    let string = "protected";

    // strn.........

    let fraction = string.length / 9;

    // protectedWord.forEach((span) => {
    //   span.innerText = "●";
    // });

    let fractionProgress = parseInt((progress * 10) / fraction);

    if (fraction < 10) {
      protectedWord.forEach((span, index) => {
        if (index < fractionProgress) {
          span.innerText = string[index];
          span.classList.remove("-dot");
        } else {
          span.classList.add("-dot");
          span.innerText = "●";
          // span.innerText = "•";
        }
      });
    }

    // protectedWord[parseInt(tween.progress() * 10)].innerText = string[parseInt(tween.progress() * 10)];

    // console.log(parseInt((progress * 10) / fraction));
    // protectedWord[]

    // backgroundLinesTl.progress(self.progress);
  },
});

ScrollTrigger.create({
  trigger: ".protected-section",
  start: "top center",
  // end: "+=2000",
  // pin: ".protected-section__content",
  // endTrigger: "#otherID",
  // end: "bottom 50%+=100px",
  onEnter: (self) => {
    document.querySelector(".nav").classList.remove("c-white");
    document.querySelector(".nav").classList.add("c-dark-grey");
    document.querySelector(".protected-section__overlay").classList.add("protected-section__overlay--visible");
  },
  onLeaveBack: () => {
    document.querySelector(".nav").classList.add("c-white");
    document.querySelector(".nav").classList.remove("c-dark-grey");
    document.querySelector(".protected-section__overlay").classList.remove("protected-section__overlay--visible");
  },
  onToggle: (self) => {
    // document.body.classList.toggle("bg-background-grey", self.isActive);
    // if (self.isActive) {
    // document.querySelector(".nav").classList.remove("c-white");
    // document.querySelector(".nav").classList.add("c-dark-grey");
    // } else {
    // document.querySelector(".nav").classList.add("c-white");
    // document.querySelector(".nav").classList.remove("c-dark-grey");
    // }
    // if ( self.progress >  )
    // console.log("progress: ", self.progress);
    // document.querySelector(".protected-section__overlay").classList.toggle("protected-section__overlay--visible", self.isActive);
    // document.querySelector(".zero-section").classList.toggle("zero-section--hidden", self.isActive);
    // document.querySelector('.zero-section').classList.toggle('zero-section--hidden')
    // gsap.to(".zero-section", {
    //   opacity: self.isActive ? 0 : 1,
    //   duration: 0.5,
    // });
    // console.log("toggled, isActive:", self.isActive);
  },
  // onUpdate: (self) => {
  //   console.log("zdrw");
  // },
});

// protect - section - outer;

// var tween = gsap.to(".protected-section__content", {
//   scrollTrigger: {
//     trigger: ".protected-section__content",
//     start: `top top`,
//     end: "+=4000",
//     pin: true,
//     markers: true,
//     scrub: true,
//   },
//   // x: 100,
//   duration: 3,
//   onUpdate: () => {
//     let progress = tween.progress();

//     // console.log(arguments);
//     let string = "protected";

//     // strn.........

//     let fraction = string.length / 9;

//     // protectedWord.forEach((span) => {
//     //   span.innerText = "●";
//     // });

//     let fractionProgress = parseInt((progress * 10) / fraction);

//     if (fraction < 10) {
//       protectedWord.forEach((span, index) => {
//         if (index < fractionProgress) {
//           span.innerText = string[index];
//         } else {
//           span.innerText = "●";
//         }
//       });
//     }

//     // protectedWord[parseInt(tween.progress() * 10)].innerText = string[parseInt(tween.progress() * 10)];

//     // console.log(parseInt((progress * 10) / fraction));
//     // protectedWord[]

//     backgroundLinesTl.progress(tween.progress());
//   },
// });
